import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const AssignShowsToUser = ({ targetUser, onClose }) => {

  const admin = useSelector((state) => state.user);

  const [shows, setShows] = useState([]);
  const [selectedShows, setSelectedShows] = useState([]);

  useEffect(() => {
    fetchShows();
  }, []);

  const fetchShows = async () => {
    try {
      const res = await axios.get("/shows");
      setShows(res.data);

      // Inicializamos los seleccionados con los shows que ya tiene asignados
      setSelectedShows(targetUser.assignedEvents || []);

    } catch (error) {
      console.error("Error cargando shows:", error);
    }
  };

  const toggleShow = (showId) => {
    setSelectedShows((prev) => {
      const updated = prev.includes(showId)
        ? prev.filter((id) => id !== showId)
        : [...prev, showId];

      
      return updated;
    });
  };

  const handleSubmit = async () => {
    try {
      
      await axios.post("/users/assign", {
        id: admin.id,
        targetId: targetUser.id,
        shows: selectedShows
      });

      Swal.fire("Asignado!", "Shows asignados correctamente", "success");
      onClose();

    } catch (error) {
      console.error("Error al asignar shows:", error);
      Swal.fire("Error", "No se pudieron asignar los shows", "error");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center">

      <div className="bg-[#0C2342] p-6 rounded text-white w-[500px]">

        <h2 className="text-xl font-bold mb-4">
          Asignar shows a {targetUser.name}
        </h2>

        <div className="max-h-[300px] overflow-y-auto flex flex-col gap-2">

          {shows.map((show) => (
            <label key={show.id} className="flex gap-2 items-center">

              <input
                type="checkbox"
                checked={selectedShows.includes(show.id)}
                onChange={() => toggleShow(show.id)}
              />

              {show.name}

            </label>
          ))}

        </div>

        <div className="flex justify-end gap-3 mt-4">

          <button className="secondary px-4 py-2" onClick={onClose}>
            Cancelar
          </button>

          <button className="primary px-4 py-2" onClick={handleSubmit}>
            Guardar
          </button>

        </div>

      </div>

    </div>
  );
};

export default AssignShowsToUser;
